// src/routes/usersRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import Users from '../pages/users/Users';
import CreateUser from '../pages/users/CreateUser';
import EditUser from '../pages/users/EditUser';
import ProtectedRoute from '../components/global/ProtectedRoute';

const usersRoutes = (
    <>
        {/* Users List */}
        <Route
            path="/users"
            element={
                <ProtectedRoute requiredPermission="users.viewAny">
                    <Users />
                </ProtectedRoute>
            }
        />

        {/* Create User */}
        <Route
            path="/users/create"
            element={
                <ProtectedRoute requiredPermission="users.create">
                    <CreateUser />
                </ProtectedRoute>
            }
        />

        {/* Edit User */}
        <Route
            path="/users/:id/edit"
            element={
                <ProtectedRoute requiredPermission="users.update">
                    <EditUser />
                </ProtectedRoute>
            }
        />
    </>
);

export default usersRoutes;